module.exports = __webpack_public_path__ + "media/recipes/76-b3913273.png";